import React from 'react';
import { Instagram, Facebook, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { FooterContentSettings } from '../../lib/footerContent';

interface FooterProps {
  settings: FooterContentSettings;
}

const Footer: React.FC<FooterProps> = ({ settings }) => {
  const {
    title,
    description,
    instagramUrl,
    facebookUrl,
    eventsUrl,
    eventsLabel,
    copyrightLabel,
  } = settings;
  const isExternalEventsUrl = /^https?:\/\//i.test(eventsUrl);
  return (
    <footer className="bg-stone-800 dark:bg-stone-950 text-white py-12 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-2xl font-light mb-4">{title}</h2>
        <p className="text-stone-300 mb-6">{description}</p>

        <div className="flex justify-center items-center gap-8 mb-8 flex-wrap">
          {instagramUrl ? (
            <a
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-stone-300 hover:text-white transition-colors group"
            >
              <Instagram className="w-5 h-5 group-hover:scale-110 transition-transform" />
              <span>Instagram</span>
            </a>
          ) : null}
          {facebookUrl ? (
            <a
              href={facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-stone-300 hover:text-white transition-colors group"
            >
              <Facebook className="w-5 h-5 group-hover:scale-110 transition-transform" />
              <span>Facebook</span>
            </a>
          ) : null}
          {eventsUrl ? (
            isExternalEventsUrl ? (
              <a
                href={eventsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-stone-300 hover:text-white transition-colors group"
              >
                <Calendar className="w-5 h-5 group-hover:scale-110 transition-transform" />
                <span>{eventsLabel}</span>
              </a>
            ) : (
              <Link
                to={eventsUrl}
                className="flex items-center gap-2 text-stone-300 hover:text-white transition-colors group"
              >
                <Calendar className="w-5 h-5 group-hover:scale-110 transition-transform" />
                <span>{eventsLabel}</span>
              </Link>
            )
          ) : null}
        </div>

        <p className="text-stone-400 text-sm">
          &copy; {new Date().getFullYear()} {copyrightLabel}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
